import { render, staticRenderFns } from "./_ewalletDetails.vue?vue&type=template&id=1be9e1b1&scoped=true&lang=pug&"
import script from "./_ewalletDetails.vue?vue&type=script&lang=js&"
export * from "./_ewalletDetails.vue?vue&type=script&lang=js&"
import style0 from "./_ewalletDetails.vue?vue&type=style&index=0&id=1be9e1b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9e1b1",
  null
  
)

export default component.exports